import { render } from "./HeroiconsSolidCalendar.vue?vue&type=template&id=8419ae0e"
const script = {}

import exportComponent from "/var/app/vendor/laravel/nova/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"HeroiconsSolidCalendar.vue"]])

export default __exports__